import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import ButtonWithSVG from "../../Components/layouts/button_with_svg";
import StepRoutes from "../../Routes/steps_routes";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import LoadingPage from "../../Components/layouts/loading";
import ProjectTrackingTable from "./Project Tracking/project_tracking_table";
import { useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcOk } from "react-icons/fc";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useSearchParams } from "react-router-dom";
import ComplatedProjectTable from "./Completed Projects/complated_projects_table";

const CompleteProjects = () => {
  const user = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    // project: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const store = useSelector((store) => store.login.user);
  const [projects, setProjects] = useState([]);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    performRequest("GET", "/clientProject/getCpName/")
      .then((res) => setProjects(res.data.clientProjectsData))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);

    performRequest(
      "GET",
      getFilteredURL(
        "/projectTracking/getComplateProjectTracking",
        page,
        filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.projectTrackingCount / 50));
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  <FcOk className="fs-2 me-1" />
                  Complete Projects
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              {/* {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                                user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                                    <div className="col-auto ms-auto d-print-none">
                                        <div className="d-flex d-none d-sm-block">
                                            <ButtonWithSVG
                                                href={"/client-project-tracking/new"}
                                                buttonText="New Project Tracking"
                                                svg={
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="icon"
                                                        width="24"
                                                        height="24"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="2"
                                                        stroke="currentColor"
                                                        fill="none"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    >
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M12 5l0 14" />
                                                        <path d="M5 12l14 0" />
                                                    </svg>
                                                }
                                            />
                                        </div>
                                    </div>
                                )} */}
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div
                        className={`accordion-body pt-0 ${
                          themeSet === "dark" ? "text-light" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search project name:"
                              value={filters.name}
                              onChange={(e) =>
                                setFilters({ ...filters, name: e.target.value })
                              }
                              placeholder="search project name..."
                            />
                          </div>
                          {/* {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                            store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN) && (
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search project:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    farmName: e.target.value,
                                  })
                                }
                                value={filters.farmName}
                              >
                                <option value="">select all</option>

                                {projects &&
                                  projects?.map((state, index) => (
                                    <option
                                      key={index}
                                      value={state?.clientName}
                                    >
                                      {state?.clientName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div>
                          )} */}
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      name: "",
                                      // leadowner: "",
                                      // project: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`accordion-body d-none d-md-block ${
                        themeSet === "dark" ? "text-light" : ""
                      }`}
                    >
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Search project name:"
                            value={filters.name}
                            onChange={(e) =>
                              setFilters({ ...filters, name: e.target.value })
                            }
                            placeholder="search project name..."
                          />
                        </div>
                        {/* {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search project:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  farmName: e.target.value,
                                })
                              }
                              value={filters.farmName}
                            >
                              <option value="">select all</option>

                              {projects &&
                                projects?.map((state, index) => (
                                  <option key={index} value={state?.clientName}>
                                    {state?.clientName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          </div>
                        )} */}
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    name: "",
                                    // leadowner: "",
                                    // project: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/ERyJHkHei5k"}
                  id={"model-viedo"}
                  name={"project tracking"}
                ></CustomViedoCard>
              </div>
              <a
                className="card mt-2 border-0"
                href="https://youtu.be/ZUH8kaLNC-Q?si=yH2WAfUTwr2aklRB"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card-body p-0">
                  <img
                    className="d-none d-sm-block"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1753079263/3_qqi0vz_spzbfu_xsfvnx.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </a>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data &&
                data?.projectTrackingData &&
                data?.projectTrackingData.length > 0 ? (
                  <ComplatedProjectTable
                    PT={data?.projectTrackingData}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                ) : (
                  <div>
                    <h2 className="text-center p-4">
                      Work order is not yet uploaded kindly make advance payment
                      to start the project.
                    </h2>
                    <h2 className="text-center">Payment Details:</h2>
                    <h3 className="text-center">
                      Name: KRYZEN BIOTECH PRIVATE LIMITED
                    </h3>
                    <h3 className="text-center">Bank: ICICI BANK</h3>
                    <h3 className="text-center">Account No.: 016905015915</h3>
                    <h3 className="text-center">IFSC: ICIC0007565</h3>
                  </div>
                )}

                {user.Role !== process.env.REACT_APP_ROLE_CLIENT &&
                  user.Role !== process.env.REACT_APP_ROLE_D_CLIENT && (
                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <ButtonWithSVG
                          href={"/client-project-tracking/new"}
                          buttonText="New Project Tracking"
                          svg={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="icon"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              strokeWidth="2"
                              stroke="currentColor"
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          }
                        />
                      </div>
                    </div>
                  )}

                {data &&
                  data?.projectTrackingData &&
                  data?.projectTrackingData.length > 0 && (
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.projectTrackingData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  )}
              </div>
              <a
                className="card mt-2 border-0"
                href="https://youtu.be/ZUH8kaLNC-Q?si=yH2WAfUTwr2aklRB"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card-body p-0">
                  <img
                    className="d-block d-sm-none"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1753079263/3_qqi0vz_spzbfu_xsfvnx.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </a>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/ERyJHkHei5k"}
                  id={"model-viedo2"}
                  name={"project tracking"}
                ></CustomViedoCard>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CompleteProjects;
